import React from 'react';
import { ClassAssembly7B2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly7B2026/>;
  };
  
  export default ClassAssemblyPage;